import { type FC } from "react";
import { KeyRound, BrainCircuit, LockKeyhole, FileX2 } from "lucide-react";

const SECURITY_PILLARS = [
  {
    icon: KeyRound,
    title: "Access is client-granted and logged",
    description:
      "Each client controls access to the estate record, and Elayne staff access is restricted to a need-to-know basis. Every grant and change is recorded, making authorization always documentable.",
  },
  {
    icon: BrainCircuit,
    title: "Data is never sold or shared",
    description:
      "Estate data is never sold or shared with third parties, and is used only to administer the estate. It stays confidential to the people your client has authorized, nothing more.",
  },
  {
    icon: LockKeyhole,
    title: "Encrypted and isolated per estate",
    description:
      "All records are encrypted in transit and at rest. Each estate is logically isolated, so no matter shares an environment with another.",
  },
  {
    icon: FileX2,
    title: "Defined retention and deletion",
    description:
      "Client-initiated deletion removes estate data, subject only to legally mandated retention. No residual archives.",
  },
];

export const SecuritySection: FC = () => {
  return (
    <div className="rounded-lg border border-primary bg-white overflow-hidden">
      <div className="p-6 flex flex-col gap-1">
        <h4>Security</h4>
        <p className="text-secondary">Elayne was built for the most sensitive matters</p>
      </div>

      <div className="border-t border-primary" />

      <div className="p-6 flex flex-col gap-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {SECURITY_PILLARS.map((pillar) => (
            <div
              key={pillar.title}
              className="rounded-lg border border-primary px-4 py-6 flex flex-col gap-3 overflow-hidden"
            >
              <pillar.icon className="h-6 w-6 text-tertiary" aria-hidden="true" />
              <div className="flex flex-col gap-2">
                <p className="text-sm font-semibold">{pillar.title}</p>
                <p className="text-sm text-primary">{pillar.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="border-t border-primary" />

        <div className="flex flex-col gap-1">
          <p className="text-base font-semibold">Delete account</p>
          <p className="text-sm">
            To delete your account, email{" "}
            <a
              href="mailto:partnerships@elayne.com"
              className="underline underline-offset-2 hover:opacity-80 transition-opacity"
            >
              partnerships@elayne.com
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};
